import { useAppContext } from "../../../../App";
import { Text, useTheme, Portal } from "@chakra-ui/react";
import { GESTAR_NAV } from "../../../../utils/constants";
import { ChevronLeftIcon, CloseIcon } from "@chakra-ui/icons";
import MenuCustom from "../../../menuCustom/menuCustom";
import SocialMedia from "../../../SocialMedia/socialMedia";
import CampusVirtual from "../campusVirtual/campusVirtual";
import { useEffect, useState } from "react";

export default function DrawerMenu({isOpen}) {
  const { 
    isMobile, 
    toggleDrawer, 
    selectedCategory, 
    setSelectedCategory,
    diploma,
    secretarys,
    categoryItems,
    setSearcherText,
    drawerSelection
  } = useAppContext();
  const theme = useTheme();
  const style = styles(theme, isMobile, isOpen);
  const [submenuTitle, setSubmenuTitle] = useState(null);
  
  useEffect(()=>{
    if(selectedCategory?.id !== 'second-menu-drawer')
      setSubmenuTitle(selectedCategory?.name)
  },[selectedCategory]);

  const itemsForSecondMenu = 
    drawerSelection?.name === "CURSOS"? categoryItems:
    drawerSelection?.name === "DIPLOMADOS"? diploma: secretarys;
  
  return (
    <Portal>
    <div style={style.container} className="sansation-bold">
      <div style={style.header}>
        <Text>Menú</Text>
        <CloseIcon
          alignSelf={'flex-end'} 
          color={'white'}
          onClick={() => toggleDrawer()}
        />
      </div>
      { ![1,2,3].includes(selectedCategory?.index) && selectedCategory?.id !== "second-menu-drawer" ?
      <div>
        
        <MenuCustom
          id={'first-menu-drawer'}
          title=""
          showRightArrow={[false, true, true,true, false, false, false]}
          items={['HOME'].concat(GESTAR_NAV.map((name, id) => ({name, id})))}
          itemRedirectTo=""
          addItemToPath={true}
          routesForItems={[
            "home",
            "categorias-general/Cursos",
            "categorias-general/Trayecto Profesional",
            "categorias-general/Trayecto Profesional",
            "in-company",
            "comunidad",
            "sobre-nosotros",
          ]}
          customStyles={style.customMenu}
          customActionOnItemclick={() =>{ 
            setSearcherText('')
            toggleDrawer()
          }}
        />
        <CampusVirtual 
          from="drawer"
          customStyles={style.campusCustom}
        />
        <SocialMedia customStyles={style.socialMedia} />
        
        
      </div>:
      <div>
        <div 
          style={{
            display:'flex',
            flexDirection: 'row',
            alignContent: 'center'
          }}
          onClick={() => setSelectedCategory(null)}
        >
          <ChevronLeftIcon width={5} height={5} />
          <Text style={style.titleSubmenu}>{submenuTitle}</Text>
        </div>
        <MenuCustom
          id={'second-menu-drawer'}
          title=""
          items={itemsForSecondMenu}
          itemRedirectTo={`categorias-general/${submenuTitle?.toLowerCase() === 'cursos' ? 'Cursos' : 'Trayecto Profesional'}`}
          addItemToPath={true}
          customStyles={style.customMenu}
          customActionOnItemclick={() =>{ 
            setSearcherText('')
            toggleDrawer()
          }}
        />
      </div>}
    </div>
    </Portal>
  );
}

const styles = (theme, isMobile, isOpen) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: "fixed",
    top: 0,
    paddingTop: '70px', // ⬅️ ajustá según la altura real de tu Header en version movil.
    right: isOpen ? 0 : "-100%",
    height: "100%",
    backgroundColor: theme.background.secondary,
    padding: "1rem",
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    color: theme.color.text.primary,
    zIndex: 1000,
    width: "80%",
    boxShadow: "2px 0 5px rgba(0, 0, 0, 0.5)",
    transition: "all 0.5s ease-in-out",
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '0.5rem',
    marginBottom: '0.5rem',
    borderBottom: '1px solid',
    borderBottomColor: theme.color.text.primary,
  },
  socialMedia:{
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      marginTop: '10%',
    }
  },
  campusCustom:{
    container:{
      padding: 0,
      margin: 10,
      width: '80%',
      justifySelf: 'center',
      borderRadius: 20,
      backgroundColor: theme.background.primary,
      marginBottom: '1.5%'
    },
    round:{
      backgroundColor: theme.background.secondary
    }
  },
  customMenu:{
    separator:{
      width: '100%'
    },
    menuItem: {
      padding: '0.50rem',
      backgroundColor: theme.background.secondary,
      color: theme.color.text.primary,
    },
  },
  titleSubmenu:{
    letterSpacing: 1.5, 
    fontSize: '1.2rem', 
    lineHeight: 1,
    marginBottom: '1%'
  }
});
